import { App } from 'App';
import { registerFirebaseEvents } from 'core/auth';
import { reducers } from 'core/redux/reducers';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './globals';
import { Store } from './utils';

const store = Store.initiate(reducers);

// must regitrate events AFTER the store initialize
registerFirebaseEvents();

const provider = (
  <Provider store={store}>
    <App />
  </Provider>
);

ReactDOM.render(provider, document.getElementById('root'));
